import { log } from 'utils/error-logging';
import contentExperienceService from 'api/definitions/content-experience-service';
import { isApiError } from 'api/client/helpers';
import { contentAdded } from './slice';

type FetchContent = {
  resourcePath: string;
  cache?: boolean;
};

export const fetchContent =
  ({ resourcePath, cache }: FetchContent) =>
  async (dispatch: WtrDispatch, getState: WtrGetState) => {
    try {
      const response = await contentExperienceService.get({
        resourcePath,
        cache: cache ? { memoryCacheMaxAge: 10000 } : undefined,
      })({
        dispatch,
        getState,
      });

      dispatch(contentAdded({ resourcePath, response }));
    } catch (error) {
      if (!isApiError(error) || error.status !== 404) {
        log(error, {
          logger: 'aem',
          section: 'fetchContent',
          extra: {
            resourcePath,
            cache,
          },
        });
      }
    }
  };
